import { PAYOUT_PERCENTAGE } from "@/constants/payout";

/**
 * Calculate the payout amount for an offer
 * @param totalAmount - The total amount of the offer in cents
 * @returns The payout amount in dollars (rounded)
 */
export const calculatePayoutAmount = (totalAmount: number): number => {
  return Math.round((totalAmount * PAYOUT_PERCENTAGE) / 100);
};
